import Vue from 'vue';

Vue.component('Timer', () => import('@/components/shared/ab_test/Timer.vue'));
Vue.component('RoundedButton', () => import('@/components/shared/elements/buttons/RoundedButton'));
Vue.component('InlineLink', () => import('@/components/shared/elements/buttons/InlineLink'));
Vue.component('LoaderSpinner', () => import('@/components/shared/elements/loaders/LoaderSpinner'));
